import Logger from './logger';
import Utils from './UtilsService';

export default class LocalStorageService {
    static getItem(key) {
        try {
            const rawResult = window.localStorage.getItem(key.toString());

            if (rawResult === undefined) {
                return undefined;
            }

            const result = JSON.parse(rawResult);

            return result;
        } catch (error) {
            Logger.error(error.message);

            return null;
        }
    }

    static setItem(key, value) {
        try {
            const stringValue = JSON.stringify(value);
            const result = window.localStorage.setItem(key.toString(), stringValue);

            return result;
        } catch (error) {
            Logger.error(error.message);

            return null;
        }
    }

    static setItemWithExpiration(key, value, ttlSec = 60) {
        try {
            const stringValue = JSON.stringify({
                value,
                expire: new Date().getTime() + ttlSec * 1000,
            });

            const result = window.localStorage.setItem(key.toString(), stringValue);

            return result;
        } catch (error) {
            Logger.error(error.message);

            return null;
        }
    }

    static getItemWithExpiration(key) {
        try {
            const stringItem = window.localStorage.getItem(key);

            if (!stringItem) {
                return null;
            }

            const item = Utils.parseJSON(stringItem);
            const now = new Date();
            if (now.getTime() > item?.expire || !item?.expire) {
                window.localStorage.removeItem(key);
                return null;
            }
            return item.value;
        } catch (error) {
            Logger.error(error.message);
            return null;
        }
    }

    static get length() {
        return window.localStorage.length;
    }

    static clear() {
        return window.localStorage.clear();
    }

    static key(index) {
        return window.localStorage.key(index);
    }

    static removeItem(key) {
        return window.localStorage.removeItem(key);
    }
}
